const base_height = 100;
const modal_height = 1000;
const popup_height = 2000;

let modal_background = null;

let chains =
{
	modal: [],
	popup: []
};

let interrupt_click = false;


//


document.addEventListener( 'click', event =>
{
	if ( interrupt_click )
	{
		interrupt_click = false;
		return;
	}
	
	let parent = event.target;
	
	while ( parent )
	{
		if ( parent.hasAttribute && parent.hasAttribute( 'er-window' ) )
			break;
		
		parent = parent.parentNode;
	}
	
	if ( !parent )
		Close_chain( 'popup' );
	else
	{
		let item = Find( parent );
		
		if ( !item )
			Close_chain( 'popup' );
		
		if ( item.chain == 'popup' )
			Close_chain( 'popup', item );
		else
			Close_chain_popups( item.chain, item );
	}
} );


export function Fix_zombie_modals ()
{
	chains.modal.forEach( item =>
	{
		if ( !item.element.parentNode )
			Close( item.element );
	} );
}


/**
 * Avaliable modes:
 * - reset = closes all the windows in the chain before opening the new window
 * - override = overrides the default behaviour (new modal/normal windows closes all popups)
 * - aspopup = open the window in the chain specified, but as if it were a popup
 * - clear = use a clear background for modals, it has no effect in any other window type
 */
export function Open ( window, funcs, chain, modes = [] )
{
	// Do nothing if the window is already somewhere in a chain
	if ( Find( window ) )
		return;
	
	switch ( chain )
	{
		case 'popup':
			if ( modes.includes( 'reset' ) )
				Close_chain( 'popup' );
			break;
		
		case 'modal':
		default:
			if ( modes.includes( 'reset' ) )
			{
				if ( modes.includes( 'aspopup' ) )
					Close_chain_popups( chain );
				else
					Close_chain( chain );
			}
			
			if ( !modes.includes( 'override' ) )
				Close_chain( 'popup' );
	}
	
	let type = 'normal';
	
	if ( modes.includes( 'aspopup' ) || ( chain == 'popup' ) )
		type = 'popup';
	else if ( chain == 'modal' )
		type = 'modal';
	
	// Open the window
	Open_window( window, funcs, chain, type, modes.includes( 'clear' ) );
}


export function Close ( window )
{
	let item = Find( window );
	
	if ( !item )
		return;
	
	let pos = false;
	
	chains[item.chain].forEach( ( chain_item, index ) =>
	{
		if ( chain_item === item )
			pos = index;
		else if ( ( pos !== false ) && ( index > pos ) )
		{
			chain_item.element.style.zIndex = parseInt( chain_item.element.style.zIndex ) - 1;
			
			if ( chain_item.blocker )
				chain_item.blocker.style.zIndex = parseInt( chain_item.element.style.zIndex ) - 1;
		}
	} );
	
	chains[item.chain].splice( pos, 1 );
	
	//
	
	item.element.setAttribute( 'er-window', 'closed' );
	
	if ( item.blocker )
		item.blocker.parentNode.removeChild( item.blocker );
	
	if ( ( pos - 1 ) >= 0 )
		chains[item.chain][pos - 1].element.setAttribute( 'er-window', 'open' );
	
	//
	
	Check_clear_background();
	
	if ( ( item.chain == 'modal' ) && ( chains.modal.length == 0 ) )
		Hide_modal_background();
}


export function Close_chain ( chain_name, from_item = null )
{
	if ( !( chain_name in chains ) )
		return;
	
	let found = from_item === null;
	
	chains[chain_name].forEach( item =>
	{
		if ( found )
			item.func.Close();
		else if ( item == from_item )
			found = true;
	} );
}


//


function Open_window ( window, func, chain, type, use_clear_background )
{
	if ( !( chain in chains ) )
		chains[chain] = [];
	
	let item = { element: window, blocker: null, func: func, chain: chain, type: type, clear: use_clear_background };
	
	//
	
	let height;
	
	if ( ( chain == 'popup' ) || ( type == 'popup' ) )
		height = popup_height + chains.popup.length;
	else if ( chain == 'modal' )
		height = modal_height + chains.modal.length;
	else
		height = base_height + Get_max_height();
	
	if ( chain == 'modal' )
	{
		Show_modal_background();
		
		item.blocker = document.createElement( 'div' );
		item.blocker.style.zIndex = height;
		item.blocker.addEventListener( 'click', event =>
		{
			event.stopPropagation();
		} );
		
		item.element.parentNode.insertBefore( item.blocker, item.element );
		
		item.blocker.setAttribute( 'er-blocker', '' );
		
		if ( type != 'popup' )
			chains.modal.forEach( chain_item => setTimeout( () => chain_item.element.setAttribute( 'er-window','waiting' ), 15 ) );
	}
	
	item.element.style.zIndex = height;
	
	setTimeout( () => item.element.setAttribute( 'er-window','open' ), 15 );
	
	interrupt_click = true;
	setTimeout( () => interrupt_click = false, 350 );
	
	chains[chain].push( item );
	
	Check_clear_background();
}


function Close_chain_popups ( chain, from_item = null )
{
	if ( !( chain in chains ) )
		return;
	
	let found = from_item === null;
	
	chains[chain].forEach( item =>
	{
		if ( ( item.type == 'popup' ) && found )
			item.func.Close();
		else if ( item == from_item )
			found = true;
	} );
}


function Find ( element )
{
	let found = false;
	
	for ( const chain in chains )
	{
		chains[chain].forEach( item =>
		{
			if ( item.element === element )
				found = item;
		} );
		
		if ( found )
			return found;
	}
	
	return false;
}


function Get_max_height ()
{
	let result = 0;
	
	for ( const chain in chains )
	{
		if ( ( chain == 'modal' ) || ( chain == 'popup' ) )
			continue;
		
		result = Math.max( result, chains[chain].length );
	}
	
	return result;
}


function Check_modal_background ()
{
	if ( !modal_background )
	{
		if ( !( modal_background = document.querySelector( '[er-background]' ) ) )
		{
			modal_background = document.createElement( 'div' );
			modal_background.setAttribute( 'er-background', '' );
			
			let layer = document.querySelector( '#emergency' );
			
			if ( layer.childNodes.length > 0 )
				layer.insertBefore( modal_background, layer.childNodes[0] );
			else
				layer.appendChild( modal_background );
		}
		
		modal_background.addEventListener( 'click', event => event.stopPropagation() );
	}
}


function Show_modal_background ()
{
	Check_modal_background();
	
	modal_background.setAttribute( 'er-background', 'open' );
}


function Hide_modal_background ()
{
	Check_modal_background();
	
	modal_background.setAttribute( 'er-background', 'closed' );
}


function Check_clear_background ()
{
	Check_modal_background();
	
	let clear = false;
	
	chains['modal'].forEach( item => clear = clear || item.clear );
	
	if ( clear )
		modal_background.setAttribute( 'er-background-mode', 'clear' );
	else
		modal_background.removeAttribute( 'er-background-mode' );
}
